import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en-US";

let initPromise;

/** English only in the main bundle; jp/zh loaded on demand after host language event. */
export const initI18n = () => {
  if (initPromise) return initPromise;
  initPromise = i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: en,
      },
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
  return initPromise;
};

/**
 * Switch UI language; loads non-English locale chunks on first use.
 * @param {string} iso - "en" | "jp" | "zh"
 */
export async function ensureAppLanguage(iso) {
  await initI18n();
  const lang = iso === "zh" ? "zh" : iso === "jp" ? "jp" : "en";

  if (lang === "en") {
    await i18n.changeLanguage("en");
    return;
  }

  if (lang === "jp") {
    if (!i18n.hasResourceBundle("jp", "translation")) {
      const mod = await import(
        /* webpackChunkName: "locale-jp" */ "./ja-JP.js"
      );
      i18n.addResourceBundle("jp", "translation", mod.default, true, true);
    }
    await i18n.changeLanguage("jp");
    return;
  }

  if (lang === "zh") {
    // Add ./zh-CN.js and a matching webpackChunkName when Chinese copy deck exists.
    await i18n.changeLanguage("en");
    return;
  }

  await i18n.changeLanguage("en");
}

export default i18n;
